// Action guard: disables an action with a tooltip when the server is read-only or, for jobs, has no launcher (from /api/v1/meta).
import type { ReactNode } from "react";

import { useActionAvailability, type ActionAvailability } from "@/app/session";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface ReadOnlyGuardProps {
  requireLauncher?: boolean;
  children: (availability: ActionAvailability) => ReactNode;
}

export function ReadOnlyGuard({ requireLauncher = false, children }: ReadOnlyGuardProps) {
  const availability = useActionAvailability(requireLauncher);
  if (!availability.disabled || availability.reason === null) {
    return children(availability);
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex rounded-sm">
          {children(availability)}
          <span className="sr-only">{availability.reason}</span>
        </span>
      </TooltipTrigger>
      <TooltipContent>{availability.reason}</TooltipContent>
    </Tooltip>
  );
}
